import { vals, round2 } from "@/lib/format";

export const AGE_BUCKETS = [
  { key: "b7", min: 0, max: 7 },
  { key: "b15", min: 8, max: 15 },
  { key: "b30", min: 16, max: 30 },
  { key: "b60", min: 31, max: 60 },
  { key: "b90", min: 61, max: 90 },
  { key: "b90p", min: 91, max: Infinity },
];

const DAY = 86400000;
export const daysSince = (iso, now = Date.now()) => Math.max(0, Math.floor((now - new Date(iso).getTime()) / DAY));
export const bucketOf = (days) => AGE_BUCKETS.find((b) => days >= b.min && days <= b.max) || AGE_BUCKETS[AGE_BUCKETS.length - 1];

// FIFO allocation: customer payments settle the oldest credit sales first.
export function debtAging(view, now = Date.now()) {
  const out = [];
  for (const c of vals(view.customers)) {
    const balance = round2(c.balance || 0);
    if (balance <= 0) continue;
    const credits = vals(view.sales).filter((s) => s.customer_id === c.id && Number(s.credit) > 0 && !s.voided)
      .map((s) => ({ id: s.id, at: s.created_at, receipt_no: s.receipt_no, amount: round2(s.credit), left: round2(s.credit) }))
      .sort((a, b) => a.at.localeCompare(b.at));
    let paid = round2(vals(view.payments).filter((p) => p.customer_id === c.id).reduce((s, p) => s + (p.kind === "refund" ? -1 : 1) * Number(p.amount || 0), 0));
    for (const cr of credits) { if (paid <= 0) break; const take = Math.min(cr.left, paid); cr.left = round2(cr.left - take); paid = round2(paid - take); }
    const open = credits.filter((cr) => cr.left > 0.009);
    const explained = round2(open.reduce((s, cr) => s + cr.left, 0));
    const residual = round2(balance - explained);
    if (residual > 0.009) open.unshift({ id: `opening-${c.id}`, at: c.created_at || c.last_purchase_at || new Date(now).toISOString(), receipt_no: null, amount: residual, left: residual, opening: true });
    const items = open.map((cr) => ({ ...cr, days: daysSince(cr.at, now), bucket: bucketOf(daysSince(cr.at, now)).key }));
    const buckets = Object.fromEntries(AGE_BUCKETS.map((b) => [b.key, round2(items.filter((i) => i.bucket === b.key).reduce((s, i) => s + i.left, 0))]));
    const oldest = items.reduce((m, i) => Math.max(m, i.days), 0);
    out.push({ customer: c, balance, items, buckets, oldest, last_payment: vals(view.payments).filter((p) => p.customer_id === c.id).map((p) => p.created_at).sort().pop() || null });
  }
  return out.sort((a, b) => b.oldest - a.oldest || b.balance - a.balance);
}

export const agingTotals = (rows) => ({
  total: round2(rows.reduce((s, r) => s + r.balance, 0)),
  buckets: Object.fromEntries(AGE_BUCKETS.map((b) => [b.key, round2(rows.reduce((s, r) => s + r.buckets[b.key], 0))])),
});
